define([
	"dojo/_base/declare",
	"csi/action",
	"csi/action/NewController"
], function(declare,action,NewController) {

	return declare(NewController, {
		_canNavigate: function() {
			// summary: disable Save&Go
			return false;
		},

		_canRepeat: function() {
			// summary: disable Save&New
			return false;
		}
	});
});